import {
  call, put, select, takeEvery, fork,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';

import HttpClient from 'circe/Http/HttpClient';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { show as showNotification } from 'circe/notifications/actions';
import actionTypes from './actionTypes';
import { failed, submitted } from './actions';

const successMessageExtractorFunction = (response) => (response && response.message ? response.message : null);

const errorMessageExtractorFunction = (response) => (response && response.message ? response.message : null);

function* doSubmit(action) {
  const { reducerName, payload } = action;

  const { url, data: payloadData, options = {} } = payload;

  const {
    successMessage,
    successMessageExtractor = successMessageExtractorFunction,
    showSuccessNotification = true,

    errorMessage,
    errorMessageExtractor = errorMessageExtractorFunction,
    showErrorNotification = true,

    delay: delaySubmitted = 0,
  } = options;

  const state = yield select();

  try {
    const headers = yield call(getCurrentAuthHeader, state);

    const client = new HttpClient();

    const data = yield client
      .Post(url)
      .withData(payloadData)
      .withHeaders(headers)
      .send();

    yield put(submitted({ reducerName, data }));

    const message = successMessage || successMessageExtractor(data);

    if (showSuccessNotification && message) {
      yield put(showNotification(message, 'success'));
    }
  } catch (e) {
    const message = errorMessage || errorMessageExtractor(e.response, e.status, e);

    if (showErrorNotification && message) {
      yield put(showNotification(message, 'error'));
    }

    yield put(failed({ reducerName, error: e.response }));
  }
}

export default function* () {
  yield takeEvery(actionTypes.SUBMIT, doSubmit);
}
